import { useEffect, useState } from "react";
import { getUserBalance } from "../services/balance";

export default function TotalAssetsMobile() {
  const [transactionAssets, setTransactionsAssets] = useState(null);
  useEffect(() => {
    getUserBalance().then(({ data }) => {
      if (data && data.data) {
        setTransactionsAssets(data.data);
      }
    });
  }, []);
  return (
    <div className="total-assets">
      <div>ارزش کل دارایی به لحظه</div>
      <div>(موجودی تومانی + طلایی + نقره ای + زرینو)</div>
      <div>
        {isNaN(transactionAssets?.total_assets)
          ? new Intl.NumberFormat("fa", {
              maximumFractionDigits: 0,
            }).format(0)
          : new Intl.NumberFormat("fa", {
              maximumFractionDigits: 0,
            }).format(transactionAssets?.total_assets)}
      </div>
    </div>
  );
}
